import { ReactElement } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { IndividualType } from 'store/individuals/individual';
import { User } from 'store/session/user';

export interface Route extends RouteObject {
    name: string;
    props?: any;
    adminRoute?: boolean;
    children?: Route[];
    restrictRoute?: IndividualType[];
    state?: any;
}

interface ProtectedRouteProps {
    user?: User;
    children: ReactElement;
    allowedUsers?: IndividualType[];
}

export const ProtectedRoute = ({ user, children, allowedUsers }: ProtectedRouteProps) => {
    if (!user) {
        return <Navigate to="/" replace />;
    }

    if (allowedUsers && !allowedUsers.includes(user.role as IndividualType)) {
        return <Navigate to="/home" replace />;
    }

    return children;
};
